import React from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { motion } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";

const posts = [
  { tag: "Strategy", title: "The 3-second hook: why most TikToks fail before they start", excerpt: "Retention data from 12M+ short-form videos reveals the same flop pattern...", read: "5 min", date: "Feb 8, 2026" },
  { tag: "Growth", title: "I posted daily for 90 days using ClipForge. Here's what worked.", excerpt: "A breakdown of the niches that hit, the hooks that flopped, and the score thresholds that mattered.", read: "8 min", date: "Feb 2, 2026" },
  { tag: "Trends", title: "Trending audio is the new SEO", excerpt: "Why creators who chase audio early outperform creators who chase topics.", read: "4 min", date: "Jan 27, 2026" },
  { tag: "AI", title: "Inside the viral score model", excerpt: "How we score scripts in real-time using retention, hook strength, and pattern matching.", read: "6 min", date: "Jan 19, 2026" },
  { tag: "Tools", title: "Captions, thumbnails, voiceovers: do all three or skip one?", excerpt: "Which content multipliers give the biggest lift per minute of effort.", read: "5 min", date: "Jan 11, 2026" },
];

export default function Blog() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white" data-testid="blog-page">
      <Navbar />
      <section className="pt-32 px-6 max-w-5xl mx-auto">
        <p className="text-[#FF3B6B] text-sm font-mono mb-3">// THE FORGE BLOG</p>
        <h1 className="text-5xl sm:text-6xl font-bold tracking-tighter">Notes from creators<br /><span className="text-white/40">who shipped daily.</span></h1>
        <p className="mt-6 text-white/60 max-w-xl">Tactics, data, breakdowns. Updated weekly.</p>

        <div className="mt-16 space-y-4">
          {posts.map((p, i) => (
            <motion.article
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.07 }}
              className="glass rounded-xl p-6 hover:border-white/30 transition-all group cursor-pointer"
              data-testid={`blog-post-${i}`}
            >
              <div className="flex items-start justify-between gap-6">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-3 text-xs">
                    <span className="bg-[#FF3B6B]/10 text-[#FF3B6B] px-2 py-0.5 rounded font-mono uppercase">{p.tag}</span>
                    <span className="text-white/40">{p.date}</span>
                    <span className="text-white/40">·</span>
                    <span className="text-white/40">{p.read} read</span>
                  </div>
                  <h2 className="text-xl md:text-2xl font-semibold tracking-tighter group-hover:text-[#FF3B6B] transition-colors">{p.title}</h2>
                  <p className="mt-2 text-white/60 text-sm">{p.excerpt}</p>
                </div>
                <ArrowRight size={20} className="text-white/30 mt-2 group-hover:text-[#FF3B6B] group-hover:translate-x-1 transition-all" />
              </div>
            </motion.article>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
